export const GRID_VARIANT_DEFAULT = 'default'
export const GRID_VARIANT_SMALL = 'small'
export const GRID_VARIANT_COLLAPSED = 'collapsed'

export const GRID_VARIANT_VERTICAL_DEFAULT = 'vertical_default'
export const GRID_VARIANT_VERTICAL_BIG = 'vertical_big'
export const GRID_VARIANT_VERTICAL_0 = '0px'
export const GRID_VARIANT_VERTICAL_8 = '8px'
export const GRID_VARIANT_VERTICAL_16 = '16px'
export const GRID_VARIANT_VERTICAL_24 = '24px'
export const GRID_VARIANT_VERTICAL_32 = '32px'
